// bg dark image

export const lightTheme = {
  body: "#fafafa",
  text: "#363537",
  toggleBorder: "#FFF",
  gradient: "linear-gradient(#39598A, #79D7ED)",
  bgGradient:
    "linear-gradient(90deg, rgba(255,255,255,1) 50%, rgba(248,248,248,1) 50%)",
  button: {
    background: "#fff",
    "border-color": "#000",
    color: "#000",
  },
  bodyBg: "#fff",
  theme: "light",
};

export const darkTheme = {
  body: "#000000",
  text: "#FAFAFA",
  toggleBorder: "#6B8096",
  gradient: "linear-gradient(#091236, #1E215D)",
  bgGradient: "linear-gradient(90deg, rgba(0,0,0,1) 50%, rgba(20,20,20,1) 50%)",

  button: {
    background: "#000000",
    "border-color": "#fff",
    color: "#fff",
  },
  bodyBg: "#141414",
  theme: "dark",
  colors: {
    dark: "#050505",
    secondaryGradient:
      "linear-gradient(180deg, #ffa72d 0%, #ffa72d 0%, #db2117 100%)",
  },
};
